import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type ReadServicesV2 = OpalApi<'ReadServicesV2', 200>
type ReadServicesV2ResponseData = OpalApiResponseDocument<'ReadServicesV2', 200>

export const readServices: ReadServicesV2 = async ({
  params,
}: Parameters<ReadServicesV2>[0] = {}) => {
  const url = new URL('/services/v2', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadServicesV2ResponseData>(url.toString())
    .then((res) => res.data)
}
